import React from 'react';
import CardKeyValue from '../../../../../card/cardKeyValue';

const YearLevelsInformation = ({ action = 'created', detail }) => {
  const { yearLevels = [] } = detail;

  return (
    <div className='flex flex-wrap gap-4 pb-2 items-strech justify-center overflow-auto'>
      {yearLevels?.length ? (
        yearLevels?.map((year, index) => (
          <CardKeyValue
            key={index}
            className='min-w-100px max-w-150px'
            title={year?.shortName || ''}
            value={year.name || ''}
          />
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default YearLevelsInformation;
